<template>
  <Form
    :action-type="actionType"
    :subtitle="subtitle"
    :disabled="wasDisabled"
    :fallback-link="fallbackLink"
    :form-body="form"
    :show-preloader="isLoadingNow"
    @on-submit="submit"
    @on-edit="setEditMode(true)"
    @on-cancel="setEditMode(false)"
  >
    <template slot="fields">
      <GlobalTimeModal
        v-if="openedModals.globalTime"
        :list-not-empty="!!(form.dates.length > 0)"
        :init-time="shiftsGlobalTime"
        @save="saveGlobalTime"
        @close="openedModals.globalTime = false"
      />
      <div
        v-for="value, key in textInputsLabels"
        :key="key"
        class="row form-group"
      >
        <div class="col-lg-12">
          <div class="col-lg-4">
            <fieldset>
              <label>{{ value }}</label>
              <input
                class="form-control"
                placeholder="Отсутствует"
                :name="formsFields.shiftsCalendar.labels[key]"
                :maxlength="formsFields.shiftsCalendar.maxLength[key]"
                :disabled="inputsWereDisabled"
                v-model.trim="form[key]"
              />
            </fieldset>
          </div>
        </div>
      </div>
      <UsersList
        class="form-group"
        :form="form"
        :inputs-were-disabled="inputsWereDisabled"
        :modal-filters="userModalFilters"
      />
      <div class="row form-group">
        <div class="col-lg-12">
          <div class="col-lg-6">
            <fieldset>
              <label>
                {{ formsFields.shiftsCalendar.labels.dates }}
                <label v-if="!inputsWereDisabled" class="field__label_required">
                  *
                </label>
              </label>
              <Calendar
                class="field__input_calendar"
                :min-date="currentDate"
                :attributes="attributes"
                @dayclick="toggleDay"
              />
            </fieldset>
          </div>
        </div>
      </div>
      <TimesList
        :action-type="actionType"
        :times="form.times"
        :inputs-were-disabled="inputsWereDisabled"
        :has-dates="!!(form.dates.length > 0)"
      >
        <template v-if="actionType !== 'read'" slot="after-label">
          <button
            type="button"
            class="field__button_pseudolink"
            @click="openedModals.globalTime = true"
          >
            (общее время)
          </button>
        </template>
      </TimesList>
    </template>
  </Form>
</template>

<script>
import { Calendar } from 'v-calendar';
import { validationMixin } from "vuelidate";
import validationSchemas from "@/user/validation-schemas";
import { shiftsCalendarService } from "@/user/api-services";

import Form from "@/_shared/widgets/Form";
import TimesList from '@/user/components/shifts-calendar/TimesList';
import UsersList from '@/user/widgets/users/UsersList';
import GlobalTimeModal from '@/user/components/shifts-calendar/GlobalTimeModal';

import { formsFields } from "@/user/constants";
import { modals } from "@/_shared/constants";
import { objectHelper } from "@/_shared/utils";
import { useForm, useNotification } from "@/_shared/mixins";
import { useMultipleDatepicker } from "@/user/mixins/shifts-calendar";
const { createFromKeys } = objectHelper;
export default {
  mixins: [
    validationMixin,
    useForm,
    useNotification,
    useMultipleDatepicker,
  ],
  components: {
    Form,
    Calendar,
    TimesList,
    UsersList,
    GlobalTimeModal,
  },
  data() {
    return {
      openedModals: {
        globalTime: false,
      },
      userModalFilters: modals.users.filters.shiftsCalendarPage,
      formsFields,
      validationSchemas,
      fallbackLink: "/shifts_calendars",
      entityName: {
        readonly: "Календарь смен",
        modify: "календаря смен",
      },
      form: createFromKeys(formsFields.shiftsCalendar.labels),
    };
  },
  validations() {
    return {
      form:  validationSchemas.shiftsCalendar,
    };
  },
  async created() {
    const addingFields = createFromKeys(formsFields.shiftsCalendar.labels);
    await this.setFormFields(addingFields, shiftsCalendarService.get).then(() => {
      if (this.actionType !== 'add') {
        this.form.dates = JSON.parse(this.form.dates);
        this.form.times = JSON.parse(this.form.times);
      } else {
        this.form.users = [];
        this.form.dates = [];
        this.form.times = {};
      }
    });
  },
  computed: {
    inputsWereDisabled() {
      return !!(this.actionType === 'read');
    },
    textInputsLabels() {
      const { name, description } = formsFields.shiftsCalendar.labels;
      return { name, description };
    },
  },
  methods: {
    async submit() {
      const callback = async () => (
        await shiftsCalendarService[this.actionType](this.form)
      );
      await this.sendForm(callback);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/user/pages/ShiftsCalendarPage.vue